<app-dialog-header [title]="'ENGAGE.HOME_SCREEN.BUTTONS.CHANGE_EXPERIENCE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <ng-container *ngIf="list.length">
        <h3 class="mb-12">{{ 'GENERAL.LABEL.SELECTED' | translate }}</h3>
        <mat-chip-set class="chip-list mb-24 wrap">
            <mat-chip class="chip" [disableRipple]="true" *ngFor="let item of list; let i = index">
                {{ item.name }}
            </mat-chip>
        </mat-chip-set>
    </ng-container>

    <div class="table-actions-wrapper">
        <div class="w-100-p table-wrapper white mat-elevation-z2" *ngIf="dataSource">
            <span id="ruler" class="ruler"></span>

            <mat-table #table [dataSource]="dataSource.data | search: searchValue" matSort>
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell class="pl-24 pr-8" *matHeaderCellDef></mat-header-cell>

                    <mat-cell #nameCell *matCellDef="let experience" class="pl-24 pr-8" fxLayout="column" fxLayoutAlign="center start">
                        <span class="text-truncate font-semibold w-100-p">{{ experience.name }}</span>
                    </mat-cell>
                </ng-container>

                <!-- Buttons Column -->
                <ng-container matColumnDef="buttons">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>

                    <mat-cell *matCellDef="let experience">
                        <div fxFlex="row" fxLayoutAlign="end center">
                            <app-flat-button [label]="'GENERAL.BUTTON.SELECT'" (onClick)="addToList(experience)" *ngIf="!experience.selected"></app-flat-button>

                            <p *ngIf="experience.selected">{{ 'GENERAL.LABEL.SELECTED' | translate }}</p>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                <mat-row *matRowDef="let experience; columns: displayedColumns" matRipple> </mat-row>
            </mat-table>
        </div>
    </div>
</div>
<div class="pt-24 action-buttons" fxLayoutAlign="flex-end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="cancel()"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="save()" [disabled]="!list.length"></app-flat-button>
</div>
